import { latestNotificationsLimit } from "./NotificationsMenu.constants";

import { INotification } from "@types";

export const getLatestNotifications = (notifications: INotification[]) =>
  notifications
    .toSorted((first, second) => Number(first.is_read) - Number(second.is_read))
    .slice(0, latestNotificationsLimit);
